export default [
	'Psychotherapy',
	'Lifestlye Counseling'
]
